import React from 'react'
import { Buttons as BaseButtons } from '@peracto/peracto-blocks-tailwind'
import EnhancedButtonsRenderer from './EnhancedButtonsRenderer'
import ButtonsForm from './Form/ButtonsForm'

/**
 * Enhanced Buttons Block
 *
 * A complete standalone Buttons block with all features from the original Chakra implementation:
 * - Button size options (xs, sm, md, lg)
 * - Ghost style variant
 * - Custom color support
 * - Loading states
 * - All original Chakra features restored
 */
const Buttons = {
    // Use our enhanced renderer instead of base
    Component: (props) => <EnhancedButtonsRenderer {...props} />,

    // Use our enhanced form with size and ghost options
    FormComponent: (props) => <ButtonsForm {...props} />,

    // Keep the base metadata and configuration
    name: BaseButtons.name,
    version: BaseButtons.version,
    text: BaseButtons.text,
    description: BaseButtons.description,
    IconComponent: BaseButtons.IconComponent,
    createInitialState: BaseButtons.createInitialState,
}

export default Buttons
